import { httpClient } from '../commons/httpClient'

export const getEmployeeNotice = (code: string, renewal: string) => {
    var encodedCode = encodeURIComponent(code)
    return renewal === null 
        ? httpClient.get(`/Employees/ichra/ee-notice?code=${encodedCode}`) 
        : httpClient.get(`/Employees/ichra/ee-notice?code=${encodedCode}&renewal=${renewal}`)
}
